// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","text":"Footer_text__2zIhj","socials":"Footer_socials__3Thye","social":"Footer_social__1qlfP"};